import React, { createContext, useCallback, useContext, useState } from "react";

const BookingCtx = createContext(null);

export function BookingProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, source: null });
  const open = useCallback((source) => setState({ isOpen: true, source: source || "unknown" }), []);
  const close = useCallback(() => setState((s) => ({ ...s, isOpen: false })), []);
  return <BookingCtx.Provider value={{ ...state, open, close }}>{children}</BookingCtx.Provider>;
}

export function useBooking() {
  const ctx = useContext(BookingCtx);
  if (!ctx) throw new Error("useBooking must be used inside <BookingProvider>");
  return ctx;
}
